module.exports = __webpack_public_path__ + "static/media/googleLoginIcon.18121477.svg";